import React, { useState } from "react";

import Button from "@mui/material/Button";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useForm } from "react-hook-form";

import { unitTypes } from "../../utils/units";

import _uniqueId from "lodash/uniqueId";

import { useSelector, useDispatch } from "react-redux";
import { addMeasurementCategory } from "../../features/personalDatabaseSlice";
import OurTextField from "../forms/OurTextField";
import OurSelect from "../forms/OurSelect";

export default function AddMeasurementCategoryDialogue(props) {
  const personalDatabaseContents = useSelector(
    (state) => state.personalDatabase.contents
  );
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  //const [dbPassword, setDbPassword] = useState('');

  const {
    //setValue,
    clearErrors,
    handleSubmit,
    //watch,
    formState: { errors },
    control,
    reset,
  } = useForm();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const [id] = useState(_uniqueId("addmeasurementcategorygialogue-"));
  /*
  React.useEffect(() => {
    triggerRef.current = handleClickOpen
  }, [])
  // PREP to create link-back to the dialogue open function
  // https://dilshankelsen.com/call-child-function-from-parent-component-in-react/
  */

  const handleClose = () => {
    clearErrors();
    reset();
    setOpen(false);
  };

  const onSubmit = (data) => {
    console.log(data);

    // generate unique ID - largest?
    let largestIdSofar = 0;

    // iterate through all - no guarantees re. ordering
    personalDatabaseContents.measurementCategories.forEach(function (
      measurementCategory,
      index
    ) {
      console.log(index);
      largestIdSofar = Math.max(largestIdSofar, measurementCategory.id);
    });

    dispatch(
      addMeasurementCategory({
        id: largestIdSofar + 1,
        name: data.categoryName,
        type: data.measurementType,
      })
    );

    handleClose();
  };

  return (
    <>
      <Button variant="contained" component="div" onClick={handleClickOpen}>
        Add Measurement Category
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>Add Measurement Category</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please specify Measurement Category name and type.
            </DialogContentText>
            <OurTextField
              autoFocus={true}
              fieldName="categoryName"
              control={control}
              errors={errors}
              label="Name"
            />

            <OurSelect
              fieldName="measurementType"
              control={control}
              errors={errors}
              label="Measurement Type"
              options={unitTypes.map((key) => ({
                label: key.description,
                value: key.name,
              }))}
              nonErrorHelpText="The Measurement Type cannot be changed later."
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSubmit(onSubmit)}>
              Add Measurement Category
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
